<template>
  <div class='upload-div'>
    <el-upload :action='action' ref='upload' name='file' :on-change='changeUpload' :auto-upload='!isCropper'
               :disabled='disabled' :http-request='customRequest' :accept='accept'
               @on-error='errorProcess' :show-file-list='showUploadList' :multiple='multiple'
               :before-upload='beforeUpload'
               :headers='headers' :limit='limitNum' :on-exceed='exceed'>
      <slot>
        <a-button>
          <pt-icon :type='inconType' v-show='inconType'></pt-icon>
          {{ buttonText }}
        </a-button>
      </slot>
    </el-upload>

    <a-modal :title="$t('key14tupianchaijian')" :visible='dialogVisible' @cancel='cancelHander' :keyboard='false'
             :maskClosable='false'
             :destroyOnClose='true' width='700px'>
      <div class='cropper-content'>
        <div class='cropper' style='text-align:center'>
          <vueCropper
            ref='cropper'
            :img='option.img'
            :outputSize='option.size'
            :outputType='option.outputType'
            :info='true'
            :full='option.full'
            :canMove='option.canMove'
            :canMoveBox='option.canMoveBox'
            :original='option.original'
            :autoCrop='option.autoCrop'
            :fixed='option.fixed'
            :fixedNumber='fixedNumber'
            :centerBox='option.centerBox'
            :infoTrue='option.infoTrue'
            :fixedBox='option.fixedBox'
          ></vueCropper>
        </div>
      </div>
      <div slot='footer' class='dialog-footer'>
        <a-button @click='cancelHander'>{{ $t('key10quxiao') }}</a-button>
        <a-button type='primary' @click='finish' :loading='loading'>{{ $t('key14queren') }}</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getSign } from '@/api/sys/oss'
import { insert } from '@/api/sys/file'
import PtIcon from '../Icon/index'
import OSS from 'ali-oss'

export default {
  components: { PtIcon },
  props: {
    number: {//用于类似于楼宇图片附件有多个类型进行区分使用,或者你想区分index
      type: Number,
      default: null
    },
    limitNum: {
      type: Number
    },
    buttonText: {
      type: String,
      default: '文件上传'
    },
    inconType: {
      type: String,
      default: null
    },
    accept: {
      type: String
    },
    action: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tradingFlag: {
      type: Boolean,
      default: false
    },
    showUploadList: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Boolean,
      default: true
    },
    status: {//文件使用状态,1 默认使用 0 临时文件
      type: Number,
      default: 0//
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: 100
    },
    fileSuffix: {
      type: String,
      default: 'png,jpg,jpeg,xlsx,xls,doc,docx,ppt,pptx,pdf,txt,rar,zip,msg'
    },
    fixedNumber: {
      type: Array,
      default: () => {
        return [16, 9]
      }// 截图框的宽高比例}
    },
    isCropper: {
      type: Boolean,
      default: false
    },
    //是否开启分片上传
    isMultipartUpload: {
      type: Boolean,
      default: true
    },
    currentNum: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      sign: {},
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      uploadData: {},
      tempCheckpoint: '',
      key: {},
      client: null,
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      picsList: [],  //页面显示的数组
      // 防止重复提交
      loading: false,
      daCurrentMum: this.currentNum,
      fileinfo: {},
      uploadNum: 0,
      fileList: []
    }
  },
  name: 'ossUpload',
  mounted() {
    if(this.tradingFlag){
      this.getSignInfo()
    }
    this.loading = false
  },
  watch: {
    'currentNum'() {
      this.daCurrentMum = this.currentNum
    }
  },
  methods: {
    /**
     * 供截图粘贴等非文件选择器场景复用同一套 OSS 上传流程。
     */
    async uploadExternalFile(file) {
      if (!file || this.disabled || !this.validateFile(file)) {
        return false
      }
      if (!file.uid) {
        file.uid = `clipboard_${Date.now()}_${Math.random().toString(16).slice(2)}`
      }
      const signReady = this.client || this.sign.host ? true : await this.getSignInfo()
      if (!signReady) {
        return false
      }
      this.fileList = [file]
      this.uploadNum = 0
      this.initData(file)
      const result = await this.startOssUploadFile(file)
      return Boolean(result && (
        result.status === 200 || (result.res && result.res.status === 200)
      ))
    },
    async changeUpload(file, fileList) {
      this.fileList = fileList
      if (this.isCropper) {
        let result = this.validateFile(file)
        if (!result) {
          return false
        }
        this.fileinfo = file
        // 上传成功后将图片地址赋值给裁剪框显示图片
        // this.$nextTick(() => {
        var reader = new FileReader()
        reader.onload = e => {
          let data
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          this.option.img = data

        }
        // 转化为base64
        // reader.readAsDataURL(file)
        // 转化为blob
        reader.readAsArrayBuffer(file.raw)
        this.dialogVisible = true
        // })
       await this.getSignInfo()
      }
    },
    exceed() {

      setTimeout(() => {
        console.log('eeeee')
        if(this.tradingFlag){
          this.$message.error('一次最多上传' + this.limitNum + '个文件')
        }else{
          this.$message.error('最多上传' + this.limitNum + '个文件')
        }
      }, 10)

    },
    cancelHander() {
      this.option.img = ''
      this.dialogVisible = false
      this.$refs.cropper.refresh()
    },
    async beforeUpload(file) {
      if (this.multiple) {
        if (this.limitNum != null && this.daCurrentMum != null) {
          if (this.limitNum <= this.daCurrentMum) {
            setTimeout(() => {
              console.log('eeeee')
              this.$message.error('最多上传' + this.limitNum + '个文件')
            }, 10)
            return false
          }
          this.daCurrentMum += 1
        }
      }

      console.log('deforeUpload')
      let result = this.validateFile(file)
      if (!result) {
        console.log('reutrn false')
        return result
      }
      let nowTime = new Date().getTime()
      if (parseInt(this.sign.expiryTime) > nowTime - 600000) {
        return true
      }
      return await this.getSignInfo()
    },

    async getSignInfo() {
      const res = await getSign()
      console.log('=====>>>>res', res)
      if (res.code == 1) {
        this.sign = res.data
        if (res.data.accessKeyId) {
          this.client = new OSS({
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
            region: 'oss-cn-shenzhen',
            // 从STS服务获取的临时访问凭证。临时访问凭证包括临时访问密钥（AccessKeyId和AccessKeySecret）和安全令牌（SecurityToken）。
            accessKeyId: res.data.accessKeyId,
            accessKeySecret: res.data.accessKeySecret,
            stsToken: res.data.stsToken,
            // 填写Bucket名称。
            bucket: res.data.bucket
          })
        }

        return true
      } else {
        this.$message.error(this.$t('upload.oss.signError'))
        console.error('=========>sgin失败')
        return false
      }
    },
    validateFile(file) {
      let isJPG = true
      if (this.fileSuffix) {
        let fileName = file.name
        let suffix = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
        isJPG = this.fileSuffix.toLowerCase().indexOf(suffix) > -1 ? true : false
        if (!isJPG) {
          this.$message.error('文件' + file.name + '格式错误,请上传' + this.fileSuffix + '.格式文件')
          return isJPG
        }
        let isImg = 'png,jpg,jpeg'.indexOf(suffix) > -1 ? true : false
        if (isImg) {
          let isLt3m = file.size / 1024 / 1024 < this.maxSize
          if (!isLt3m) {
            this.$message.error('文件' + file.name + '过大,请上传30M以内的图片!')
            return false
          }
        }
        let isDoc = 'doc,pptx,xls,txt'.indexOf(suffix) > -1 ? true : false
        if (isDoc) {
          let isLt10m = file.size / 1024 / 1024 < this.maxSize
          if (!isLt10m) {
            this.$message.error('文件' + file.name + '过大,请上传' + this.maxSize + 'M以内的文件!')
            return false
          }
        }
      }

      const isLt2M = file.size / 1024 / 1024 < this.maxSize
      if (!isLt2M) {
        this.$message.error('文件' + file.name + '过大,请上传' + this.maxSize + 'M以内的文件!')
      }
      return isJPG && isLt2M
    },
    initData(file) {
      let body = new FormData()
      body.append('OSSAccessKeyId', this.sign.accessid)
      body.append('policy', this.sign.policy)
      this.key = this.sign.dir + '/' + file.uid + '_' + file.name
      body.append('key', this.key)
      body.append('signature', this.sign.signature)
      body.append('success_action_status', '200')
      body.append('submit', 'Upload to OSS')
      if (!this.isCropper) {
        body.append('file', file)
      }
      this.uploadData = body
      console.log('====>>>>等待上传文件', body)
    },
    async putObject(data, fileInfo) {
      let _this = this
      if (this.isMultipartUpload) {
        try {
          _this.$loading.show({
            tip: '正在上传...'
          })
          // 填写Object完整路径和本地文件的完整路径。Object完整路径中不能包含Bucket名称。
          // 您可以通过自定义文件名（例如exampleobject.txt）或目录（例如mytestdoc/exampleobject.txt）的形式，实现将文件上传到当前Bucket或Bucket中的指定目录。
          // 如果未指定本地路径，则默认从示例程序所属项目对应本地路径中上传文件。
          let key = this.sign.dir + '/' + (data.uid ? data.uid : fileInfo.uid) + '_' + (data.name ? data.name : fileInfo.name)
          let result = await this.client.multipartUpload(key, data, {
            progress: (p, checkpoint) => {
              // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
              // console.log('断点记录',p,checkpoint)
              this.$loading.show({
                tip: '正在上传,' + (p * 100).toFixed(2) + '%'
              })
              this.tempCheckpoint = checkpoint
            },
            checkpoint: this.tempCheckpoint
          })
          this.tempCheckpoint = null
          if (result.res && result.res.status == 200) {
            data.key = key
            if (fileInfo) {
              fileInfo.key = key
            }
            this.uploadChange({}, fileInfo ? fileInfo : data)
          } else {
            console.log('当前上传数量uputObject1')
            this.uploadNum = this.uploadNum + 1
            this.$loading.hide()
            this.errorProcess('上传到阿里云失败')
          }
          return result
        } catch (e) {
          console.log('当前上传数量uputObject2')

          this.uploadNum = this.uploadNum + 1
          this.$loading.hide()
          console.error(e)
          this.$emit('error', e)
        }
      } else {
        try {

          // 填写Object完整路径和本地文件的完整路径。Object完整路径中不能包含Bucket名称。
          // 您可以通过自定义文件名（例如exampleobject.txt）或目录（例如mytestdoc/exampleobject.txt）的形式，实现将文件上传到当前Bucket或Bucket中的指定目录。
          // 如果未指定本地路径，则默认从示例程序所属项目对应本地路径中上传文件。
          _this.$loading.show({
            tip: '正在上传...'
          })
          let key = this.sign.dir + '/' + (data.uid ? data.uid : fileInfo.uid) + '_' + (data.name ? data.name : fileInfo.name)
          let result = await this.client.put(key, data, {
            progress: (p, checkpoint) => {
              // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
              console.log(p, checkpoint)
              console.log('上传进度处理')
              _this.$loading.show({
                tip: '正在上传,' + (p * 100).toFixed(2) + '%'
              })
              this.tempCheckpoint = checkpoint
            },
            checkpoint: this.tempCheckpoint
          })
          this.tempCheckpoint = null
          console.log('图片上传完结果======', result)
          if (result.res && result.res.status == 200) {
            data.key = key
            if (fileInfo) {
              fileInfo.key = key
            }
            this.uploadChange({}, fileInfo ? fileInfo : data)

          } else {
            this.$loading.hide()
            this.errorProcess('上传到阿里云失败')
          }

          return result
        } catch (e) {
          this.$loading.hide()
          console.error(e)
          this.$emit('error', e)
        }
      }

    },
    async startOssUploadFile(data, fileInfo) {
      console.log('开始上传', data, fileInfo)
      let result = await this.putObject(data, fileInfo)
      this.$refs.upload.clearFiles()
      this.loading = false
      if (result && result.status == 200) {
      }
      this.dialogVisible = false
      if (this.isCropper) {
        this.option.img = ''
      }
      return result

    },
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        this.loading = true
        //上传阿里云服务器
        this.initData(this.fileinfo)
        this.startOssUploadFile(data, this.fileinfo)
      })
    },
    customRequest(option) {
      this.initData(option.file)
      if (this.client) {
        this.startOssUploadFile(option.file)
        console.log('customer request', option)
      } else {
        if (this.sign.host) {
          // this.$loading.show()
          this.$http.post(this.sign.host, this.uploadData, {
            headers: this.headers, onUploadProgress: ({ total, loaded }) => {
              // 进行上传进度输出，更加直观
              let value = Math.round(loaded / total * 100).toFixed(2)
              console.log(value)
              this.$loading.show({
                tip: '正在上传,' + value + '%'
              })
              option.onProgress({ percent: value }, option.file)
            }
          }).then(res => {
            let data = option.file
            data.key = this.key
            this.uploadChange(res, option.file)
          }).catch(error => {
            this.errorProcess(error, option.file)
          }).finally(() => {
            this.$loading.hide()
          })
        }
      }

    },
    uploadChange(res1, file) {
      console.log('success,', res1, file)
      let _this = this
      //保存信息到后台.返回文件id给前端使用
      insert(this.buildInsertData(file)).then(res => {
        this.$loading.hide()
        if (res.code == 1) {
          this.dialogVisible = false
          if (this.isCropper) {
            this.option.img = ''
          }
          if (this.number != null) {
            this.$emit('onSuccess', file, res.data, this.number)
          } else {
            this.$emit('onSuccess', file, res.data)
          }
          console.log('当前上传数量uploadChangeif1')
          this.uploadNum = this.uploadNum + 1
          if (!this.multiple) {
            this.$message.success(_this.$t('upload.oss.uploadSuccess'))
          }
        } else {
          console.log('当前上传数量uploadChangeif3')
          this.uploadNum = this.uploadNum + 1
        }
      }).catch(error => {
        console.log('当前上传数量uploadChangeif2')
        this.uploadNum = this.uploadNum + 1
        console.log(error)
        if (!this.multiple) {
          this.$message.error(this.$t('upload.oss.uploadError'))
        }
      }).finally(() => {
        console.log('当前上传数量', this.uploadNum)
        console.log('当前上传列表数量', this.fileList)
        if (this.uploadNum == this.fileList.length) {
          this.fileList = []
          this.$emit('onFinishSuccess')
        }
      })

    },
    errorProcess(err, file, fileList) {
      if (this.isCropper) {
        this.option.img = ''
      }
      if (!this.multiple) {
        this.$message.error(this.$t('upload.oss.uploadError'))
      }
      console.log(err)
      this.$emit('error', err)
    },
    buildInsertData(file) {
      let fileDO = {
        fileName: file.name,
        filePath: file.key,
        fileSize: file.size,
        status: this.status
      }
      return fileDO
    }
  }
}
</script>

<style scoped lang='less'>
.upload-div {
  /deep/ input {
    display: none !important;
  }
}

.cropper-content {
  .cropper {
    width: auto;
    height: 400px;
  }
}
</style>
